import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
  LinearProgress,
  IconButton,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useDispatch } from "react-redux";
import { setShowTour } from "../../../src/components/app/features/auth/AuthSlice";
import Back from "../../assets/Backdialog.svg"
import SignupImage from "../../assets/firstSignupImage.svg"
import { userLSAuth } from '../../../src/components/app/features/env';

const ParroticaOnboardingDialog = ({ isOpen, onClose }) => {
  const [internalOpen, setInternalOpen] = useState(isOpen ?? false);

  // keep local state in sync with parent
  useEffect(() => {
    if (typeof isOpen === "boolean") {
      setInternalOpen(isOpen);
    }
  }, [isOpen]);

  const [step, setStep] = useState(1);
  const [selectedPurpose, setSelectedPurpose] = useState("");
  const [selectedSource, setSelectedSource] = useState("");

  const dispatch = useDispatch();

  const purposeOptions = [
    "Send messages to my customers",
    "Run my political campaign",
    "Organize my event",
    "Use API to integrate Parrotica",
    "Just having a look around",
    "Other",
  ];

  const sourceOptions = [
    "A friend",
    "Social media",
    "Google search",
    "Online Ad",
    "At an event",
    "Other",
  ];

  const handleSkip = () => {
    if (step === 1) {
      setStep(2);
    } else {
      handleFinish();
        dispatch(setShowTour(true));
        
    }
  };

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

const handleContinue = () => {
  if (step === 1 && selectedPurpose) {
    setStep(2);
  } else if (step === 2 && selectedSource) {
    handleFinish(); 
     dispatch(setShowTour(true));
  }
};


  const closeDialog = () => {
    setInternalOpen(false);
    onClose?.(); 
  };

  const handleFinish = () => {
    const onboardingData = {
      purpose: selectedPurpose,
      source: selectedSource,
     
    };
    console.log("Onboarding Data:", onboardingData);
    closeDialog();
  };

  const handleTakeTour = () => {
    handleFinish();
    dispatch(setShowTour(true));
  };

  const renderStep1 = () => (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <IconButton onClick={handleBack} disabled={step === 1}>
          <img src={Back} alt="" /> <Typography sx={{color:'#2E2C21', fontWeight:'400',fontSize:{xs:'0.7rem',sm:'1rem'}}}>Back</Typography>
        </IconButton>
        <Box onClick={handleSkip}  size="small">
            <Typography sx={{color:'#2E2C21', fontWeight:'400',fontSize:{xs:'0.7rem',sm:'1rem'},cursor:'pointer',mb:'0.4rem'}}>  Skip personalization </Typography>
       
        </Box>
      </Box>

      <Typography className="font-cormorant" sx={{color:'#2E2C21', fontWeight:'600',fontSize:{xs:'1.4rem',sm:'1.8rem',md:'2.5rem'}, maxWidth:'400px'}} variant="h5" gutterBottom>
        What do you want to use Parrotica for?
      </Typography>
      <Typography variant="body2" sx={{color:'#58564d', fontWeight:'400'}} color="text.secondary" mb={3}>
        Pick the option that best describes your current need
      </Typography>

      <RadioGroup
        value={selectedPurpose}
        onChange={(e) => setSelectedPurpose(e.target.value)}
      >
        {purposeOptions.map((option) => (
          <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
        ))}
      </RadioGroup>

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 3,background:'#0040BF' }}
        disabled={!selectedPurpose}
        onClick={handleContinue}
      >
        Continue
      </Button>
    </Box>
  );

  const renderStep2 = () => (
    <Box>
    

       <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <IconButton onClick={handleBack}>
          <img src={Back} alt="" /> <Typography sx={{color:'#2E2C21', fontWeight:'400',fontSize:{xs:'0.7rem',sm:'1rem'}}}>Back</Typography>
        </IconButton>
        <Box onClick={handleSkip}  size="small">
            <Typography sx={{color:'#2E2C21', fontWeight:'400',fontSize:{xs:'0.7rem',sm:'1rem'},cursor:'pointer',mb:'0.4rem'}}>  Skip  </Typography>
       
        </Box>
      </Box>

   
         <Typography className="font-cormorant" sx={{color:'#2E2C21', fontWeight:'600',fontSize:{xs:'1.4rem',sm:'1.8rem',md:'2.5rem'}, maxWidth:'400px'}} variant="h5" gutterBottom>
        How did you find us?
      </Typography>
      <Typography variant="body2" sx={{color:'#58564d', fontWeight:'400'}} color="text.secondary">
        Your answer helps us reach more people like you
      </Typography>

      <RadioGroup
        value={selectedSource}
        onChange={(e) => setSelectedSource(e.target.value)}
      >
        {sourceOptions.map((option) => (
          <FormControlLabel key={option} value={option} control={<Radio />} label={option} />
        ))}
      </RadioGroup>

      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 3,background:'#0040BF' }}
        disabled={!selectedSource}
        onClick={handleContinue}
      >
        Finish Setup
      </Button>
    </Box>
  );



  return (
  <Dialog open={internalOpen} onClose={closeDialog} maxWidth="sm" fullWidth>
{step === 1 && (
  <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
    <LinearProgress
      variant="determinate"
      value={(step / 2) * 100}
      sx={{
        height: 6,
        width: "89%",
        "& .MuiLinearProgress-bar": {
          backgroundColor: "#0040bf",
        },
        backgroundColor: "#e3e3e3", 
        borderRadius: 2,
      }}
    />
  </Box>
)}

  <DialogContent>
    {step === 1 && renderStep1()}
    {step === 2 && renderStep2()}
    
  </DialogContent>
</Dialog>

  );
};

export default ParroticaOnboardingDialog;
